// extracted by mini-css-extract-plugin
    if(module.hot) {
      // 1752659659788
      var cssReload = require("D:/soft/HBuilderX.4.08.2024040127/HBuilderX/plugins/uniapp-cli/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"publicPath":"/","locals":false});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  